import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';
export const useStyles = makeStyles(
  (theme) => ({
    footer: {
      padding: theme.spacing(1, 2, 1, 1),
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      gap: theme.spacing(0.5),
      alignItems: 'center',
      height: 40,
    },
    footerLeft: { display: 'flex' },
    footerButton: {
      color: COLORS.primary.default,
      minWidth: 'auto',
      height: 'auto',
      fontSize: theme.typography.pxToRem(12),
      lineHeight: theme.typography.pxToRem(20),
      fontWeight: theme.typography.fontWeightMedium,
      padding: theme.spacing(0.5, 1),

      '&:hover': {
        backgroundColor: COLORS.primary.silver,
      },
    },
    tooltip: {
      maxWidth: 'none',
      padding: theme.spacing(1),
    },
    startIcon: {
      marginRight: theme.spacing(0.5),
    },
    attachmentsWrapper: {
      paddingTop: theme.spacing(1),
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      marginLeft: theme.spacing(2),
      marginRight: theme.spacing(2),
      gap: theme.spacing(1),
    },
    attachmentsWrapperNoActions: {
      paddingBottom: theme.spacing(1),
    },
    promptDocument: {
      maxWidth: ({ promptDocuments, isSlim }) =>
        promptDocuments && Object.keys(promptDocuments).length > 2 ? (isSlim ? 60 : 105) : 140,
      height: 32,
      backgroundColor: COLORS.gray.gray90,
      borderRadius: theme.shape.borderRadiusSmall,
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'start',
      padding: theme.spacing(0, 1),
      color: COLORS.gray.gray30,
      fontSize: theme.typography.pxToRem(12),
      lineHeight: theme.typography.pxToRem(16),
      '& span > svg': {
        visibility: 'hidden',
      },
      '&:hover': {
        '& span > svg': {
          visibility: 'visible',
        },
        boxShadow: ({ isUploadingDocument }) =>
          isUploadingDocument ? 'none' : theme.shape.boxShadowNormal,
      },
    },
    documentIcon: { fontSize: theme.typography.pxToRem(16), color: COLORS.gray.gray30 },
    documentLabel: {
      width: '100%',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      marginLeft: theme.spacing(1),
    },
    promptImage: {
      width: 32,
      height: 32,
      position: 'relative',
      '& svg': {
        visibility: 'hidden',
      },
      '&:hover': {
        '& svg': {
          visibility: 'visible',
        },
        boxShadow: theme.shape.boxShadowNormal,
      },
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundSize: 'cover',
      borderRadius: '4px',
      border: theme.shape.borderGray80,
    },
    promptImageLoading: {
      width: 32,
      height: 32,
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundPosition: 'center',
      borderRadius: '4px',
      backgroundColor: COLORS.gray.gray50,
    },
    removeElement: {
      backgroundColor: COLORS.gray.gray40,
      color: COLORS.neutral.white,
      borderRadius: '100%',
      border: '2px solid white',
      fontSize: theme.spacing(2),
      position: 'absolute',
      top: -8,
      right: -8,
      padding: theme.spacing(0.25),
      cursor: 'pointer',
    },
    documentLoader: { width: 'auto', height: 'auto', marginLeft: theme.spacing(1) },

    documentTooltip: {
      width: 190,
      maxHeight: 215,
    },
  }),
  { name: 'Footer' }
);
